import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';

const Page = forwardRef(({ children, title = '', bgColor = 'bg-navbar', ...other }, ref) => {
  return (
    <div className={`flex h-full min-h-0 w-full flex-1 flex-col ${bgColor} `} ref={ref} {...other}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  bgColor: PropTypes.string
};

export default Page;
